define('uikit/modules/modal2',['require','exports','module','underscore','marionette','backbone.radio','../mixins/component.mixin','../collections/container','../collections/grid','../templates','../channel','../extra/size','../extra/transition','../helper/dom','../elements/text','../collections/components.container.view','../elements/button','../extra/static.methods','semantic/modules/modal'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      Mn                      = require('marionette'),
      Radio                   = require('backbone.radio'),
      ComponentMixin          = require('../mixins/component.mixin'),
      ContainerView           = require('../collections/container'),
      Grid                    = require('../collections/grid'),
      Templates               = require('../templates'),
      channel                 = require('../channel'),
      Size                    = require('../extra/size'),
      Transition              = require('../extra/transition'),
      DOMHelper               = require('../helper/dom'),
      TextView                = require('../elements/text'),
      ComponentsContainerView = require('../collections/components.container.view'),
      ButtonView              = require('../elements/button'),
      StaticMethods           = require('../extra/static.methods');

  //initializes the view with Semantic UI modal functionality
  require('semantic/modules/modal');

  var ModalDenyButtonView = ButtonView.extend({
    updateAttributes: function() {
      ButtonView.prototype.updateAttributes.apply(this, this.options);

      if (this.getOption('approvable')) {
        this.addClass('approve');
      }
      this.addClass('deny');
    },
  });

  var ModalConfirmButtonView = ButtonView.extend({
    updateAttributes: function() {
      ButtonView.prototype.updateAttributes.apply(this, this.options);

      if (this.getOption('approvable')) {
        this.addClass('approve');
      }
      this.addClass('confirm');
    },
  });

  var ModalHeaderView = TextView.extend({
    tagName: 'div',
    className: 'header',
  });

  var ModalActionsView = ComponentsContainerView.extend({
    className: 'actions',
    childView: ButtonView,
    childViewOptions: {
      approvable: false,
    },
    components: [
      {
        type: ModalDenyButtonView,
        name: 'denyButton',
        text: 'Cancel',
        color: 'basic',
      },
      {
        type: ModalConfirmButtonView,
        name: 'confirmButton',
        text: 'Confirm',
        color: 'positive',
      },
    ],
  });

  var ModalContentView = ComponentsContainerView.extend({
    options: {
      largeFont: false,
    },
    updateAttributes: function() {
      if (this.getBoolOption('largeFont')) {
        this.addClass('content');
      } else {
        this.addClass('ui basic segment');
      }
    },
  });

  var ModalSimpleContentView = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'content',

    template: Templates.UIKit['modal.content'],

    options: {
      text: '',
      icon: '',
    },

    forceUpdate: { text: true, icon: true },
  });

  var ModalView = Mn.ItemView.extend(ComponentMixin).extend(
    {
      className: 'ui modal',

      template: Templates.UIKit['modal2'],

      options: {
        closeIcon: 'close',
        visible: false,
        allowMultiple: false,
        closeable: true,

        // keeping for legacy support (support the Semantic UI mispelling of the word)
        closable: null,
        transition: 'scale',
        fullscreen: false,
        size: '',
        basic: false,

        // prevents semantic modal module
        // from refreshing the modal position
        // when the dom tree changes
        disablePositionRefresh: false,

        // causes the modal to be destroyed
        // when it is hidden
        destroyOnHidden: true,

        //Any Semantic UI modal widget with a class name of "approve" that triggers a modal closing event will evaluate
        //this method before being allowed to close the modal.  If the function evaluates false, closing the
        //modal is halted. Default is to always allow closing
        onApprove: function() {
          return true;
        },
      },

      injectInternalViewsSynchronously: true,

      transitionOptionValues: _.values(Transition),
      sizeOptionValues: _.values(Size),

      forceUpdate: {
        closeIcon: true,
        allowMultiple: true,
        closable: true,
        closeable: true,
        transition: true,
      },

      events: {
        'keydown .close': function(ev) {
          if (ev.keyCode == 13) {
            ev.target.click();
          }
        },
      },

      triggers: {
        'click .confirm': {
          event: 'confirm',
          stopPropagation: false,
          preventDefault: false,
        },
        'click .deny': {
          event: 'deny',
          stopPropagation: false,
          preventDefault: false,
        },
      },

      internalViewOptions: {
        headerView: function() {
          return _.extend(
            {
              type: ModalHeaderView,
            },
            Mn._getValue(this.getOption('header'), this)
          );
        },
        contentView: function() {
          return _.extend(
            {
              type: ModalContentView,
            },
            Mn._getValue(this.getOption('content'), this)
          );
        },
        actionsView: function() {
          return _.extend(
            {
              type: ModalActionsView,
            },
            Mn._getValue(this.getOption('actions'), this)
          );
        },
      },

      initialize: function(options) {
        ComponentMixin.initialize.apply(this, arguments);

        ModalView.registerModalView(this);

        this.on('change:visible', function() {
          if (this.visible === true && !this.isRendered) {
            this.show({ force: true });
          }
        });

        this.on('modal:show', function() {
          var modal = this.$el.get(0);

          $(document.body).on('keydown.modal', function(ev) {
            DOMHelper.stickFocusWithinElement(ev, modal);
          });

          this.visible = true;
        });

        this.on('modal:show', function() {
          this.denyWasPressed = false;
          this.confirmWasPressed = false;
        });
        this.on('deny', function() {
          this.denyWasPressed = true;
        });
        this.on('confirm', function() {
          this.confirmWasPressed = true;
        });

        this.on('modal:visible', function() {
          this.visible = true;
        });

        this.on('modal:hide', function() {
          $(document.body).off('.modal');

          this.visible = false;
        });

        this.on('modal:hidden', function(self, options) {
          this.$el.css('margin-top', '0px');
          this.visible = false;
          _.defer(
            _.bind(function() {
              if (this.getOption('destroyOnHidden') && !_.result(options, 'resistDestroy')) {
                this.destroy();
              }
            }, this)
          );
        });

        this.on('render', function() {
          this.setupModalModule();
        });

        this.on('confirm deny', function() {
          this.visible = false;
        });

        if (this.visible === true) {
          this.show({ force: true });
        }
      },

      updateAttributes: function() {
        this.addClass('fullscreen', this.getBoolOption('fullscreen'))
          .addClass(this.getOption('size'), this.getBoolOption('size'))
          .addClass('basic', this.getBoolOption('basic'))
          .addClass('standard', !this.getBoolOption('size') && !this.getBoolOption('basic'));
      },

      setupModalModule: function() {
        //prettier-ignore
        var self      = this,
            MutationObserver,
            onApprove = this.getOption('onApprove'),
            closeable =
              this.getOption('closable') !== null ? this.getBoolOption('closable') : this.getBoolOption('closeable');

        if (this.getOption('disablePositionRefresh') && 'MutationObserver' in window) {
          MutationObserver = window.MutationObserver;
          delete window.MutationObserver;
        }

        this.$el.modal(
          _.extend({}, this.options, {
            // semantic uses closable but we like closeable better
            // so we support both options
            closable: closeable,
            //onApprove must always be passed in as a function to be directly evaluated, as deferring its evaluation
            //through a triggerMethod evalutes truthy and prevents supression of closing the modal.
            onApprove: onApprove,

            //Other native semantic UI functions that will be handled via UIKit and FuKit
            onShow: function() {
              self.triggerMethod('modal:show', self, {});
            },
            onVisible: function() {
              self.triggerMethod('modal:visible', self, {});
            },
            onHide: function() {
              var options = {
                denyWasPressed: self.denyWasPressed,
                confirmWasPressed: self.confirmWasPressed,
              };
              self.triggerMethod('modal:hide', self, options);
            },
            onHidden: function() {
              var options = {
                denyWasPressed: self.denyWasPressed,
                confirmWasPressed: self.confirmWasPressed,
              };
              self.triggerMethod('modal:hidden', self, options);
            },
          })
        );

        if (MutationObserver) {
          window.MutationObserver = MutationObserver;
        }
      },

      _show: function() {
        var self = this;

        if (!this.isRendered) {
          this.render();
        }

        _.defer(function() {
          self.$el.modal('show');
        });
      },

      _hide: function() {
        var self = this;

        if (!this.isRendered) {
          this.render();
        }

        _.defer(function() {
          self.$el.modal('hide');
        });
      },
    },
    _.extend({}, StaticMethods, {
      registerModalView: function(modalView) {
        if (!modalView) {
          return;
        }
        var name = modalView.getOption('name');

        function hideModal() {
          modalView.visible = false;
        }
        modalView.on('modal:show', function() {
          Radio.replyOnce('modals', 'hideCurrent', hideModal);
          if (name) {
            Radio.replyOnce('modals', 'hide:' + name, hideModal);
          }
          Radio.reply('modals', 'currentModal', modalView);
        });
        modalView.on('destroy', function() {
          Radio.stopReplying('modals', 'hideCurrent', hideModal);
          if (name) {
            Radio.stopReplying('modals', 'hide:' + name, hideModal);
          }
          Radio.stopReplying('modals', 'currentModal', modalView);
        });
        Radio.reply('modals', 'lastInitialized', modalView);
      },
    })
  );

  //prettier-ignore
  ModalView.DenyButtonView    = ModalDenyButtonView,
  ModalView.ConfirmButtonView = ModalConfirmButtonView,
  ModalView.HeaderView        = ModalHeaderView,
  ModalView.ActionsView       = ModalActionsView,
  ModalView.ContentView       = ModalContentView,
  ModalView.SimpleContentView = ModalSimpleContentView;

  ModalView.SMALL_SIZE = 'small';
  ModalView.LARGE_SIZE = 'large';

  channel.reply('modal2', function() {
    return ModalView;
  });

  module.exports = ModalView;
});

